import { State } from "./types";

export const pushCellHistory = (
  state: State,
  cells: State["cells"],
  otherFields: Omit<Omit<Omit<Partial<State>, "cells">, "cellHistory">, "cellHistoryIndex"> = {},
): State => {
  const cellHistory = [...state.cellHistory.slice(0, state.cellHistoryIndex + 1), cells];
  return {
    ...state,
    ...otherFields,
    cellHistory,
    cellHistoryIndex: cellHistory.length - 1,
    cells,
  };
};
